<div class="calendar-months">
  @for (month of months; track trackByMonth($index, month)) {
    <myre-month-view
      [activeDate]="month.startDate"
      [nbOfWeeksToAdd]="month.nbOfWeeksToAdd"
      [selectedDates]="selectedDates"
      [dateClass]="dateClass.bind(this)"
      [dateFilter]="dateFilter"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [eventCalendar]="eventCalendar"
      [events]="events"
      [canEdit]="canEdit"
      (selectedChange)="onSelectDate($event)"
      (onEventCreated)="onEventCreatedEmit($event)"
      (onEventUpdated)="onEventUpdatedEmit($event)"
    />
  }
</div>
